module.exports = __webpack_public_path__ + "img/ic_qmarker_greasetrap_cluster_issue.8918729f.png";